/** Versão exibida na interface (rodapé, sidebar). */
export const APP_DISPLAY_VERSION = 'v26.09.29';
